// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"VideoPlayer_videoWrapper__AJZN9","video":"VideoPlayer_video__rCHx2"};